export default {
	ADD_DEPOT(state, item) {
		state.depots.push(item);
	},
	SET_DEPOTS(state, depots) {
		state.depots = depots || [];
	},
	UPDATE_DEPOT(state, product) {
		const productIndex = state.depots.findIndex((p) => p.id === product.id);
		Object.assign(state.depots[productIndex], product);
	},
	REMOVE_DEPOT(state, itemId) {
		const ItemIndex = state.depots.findIndex((p) => p.id === itemId);
		state.depots.splice(ItemIndex, 1);
	},
};
